import React from "react";
import { BadgeCheck, Quote } from "lucide-react";
import { Reveal } from "../common/Section";
import { useContent, FOUNDER_PHOTOS } from "../../cms/ContentContext";

const SECTORS = ["Banking", "Mortgages", "Wealth & investment", "Insurance", "Consumer credit", "Payments & fintech", "Defence suppliers", "Public sector"];

export default function CredibilityStrip() {
  const { content } = useContent();
  const team = content.team || [];
  return (
    <section className="border-t border-border py-14 lg:py-16 bg-muted/40">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid lg:grid-cols-[1.15fr_1fr] gap-8 lg:gap-12 items-center">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-primary">Built for regulated, high-stakes environments</p>
            <ul className="mt-4 grid grid-cols-2 sm:flex sm:flex-wrap gap-x-6 gap-y-2.5" data-testid="sector-list">
              {SECTORS.map((s) => (
                <li key={s} className="inline-flex items-center gap-2 text-sm text-foreground/85">
                  <span className="h-1.5 w-1.5 shrink-0 bg-primary" aria-hidden="true" />{s}
                </li>
              ))}
            </ul>
            <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3">
              <span className="inline-flex items-center gap-2 text-sm text-muted-foreground"><BadgeCheck className="h-5 w-5 text-signal-green" /> ISO 9001 certified</span>
              <span className="inline-flex items-center gap-2 text-sm text-muted-foreground"><BadgeCheck className="h-5 w-5 text-signal-green" /> ISO 42001 certified</span>
              <span className="inline-flex items-center gap-2 text-sm text-muted-foreground"><BadgeCheck className="h-5 w-5 text-signal-amber" /> SOC 2 on roadmap</span>
            </div>
          </Reveal>
          <Reveal delay={100}>
            <figure className="rounded-lg border border-border bg-card p-6 lg:p-7 shadow-sm">
              <Quote className="h-7 w-7 text-primary/40" />
              <blockquote className="mt-3 text-lg font-medium text-foreground leading-relaxed text-balance">
                Adopting AI shouldn't mean losing control. We built norse3 so teams can move fast and still answer for every interaction.
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <div className="flex -space-x-2.5 shrink-0">
                  {team.slice(0, 4).map((m) => {
                    const p = m.photo || FOUNDER_PHOTOS[m.initials];
                    return p ? (
                      <img key={m.name} src={p} alt={m.name} loading="lazy" className="h-9 w-9 rounded-full object-cover ring-2 ring-card" />
                    ) : (
                      <span key={m.name} className="h-9 w-9 rounded-full bg-primary/12 text-primary ring-2 ring-card inline-flex items-center justify-center text-xs font-semibold">{m.initials}</span>
                    );
                  })}
                </div>
                <span className="text-sm text-muted-foreground min-w-0">The norse3 founding team — financial services, security &amp; AI</span>
              </figcaption>
            </figure>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
